import { useState } from 'react'
import classnames from 'classnames/bind'
import { useTranslation } from 'next-i18next'

// Libs
import { reactHelpArticle, HelpReaction } from '@/api/reactHelpArticle'
import { getVisitorId } from '@/methods/recommendTracking'

// Styles
import styles from '../../style.module.scss'

const cx = classnames.bind(styles)

const REACTIONS: { value: HelpReaction; emoji: string; labelKey: string }[] = [
  { value: 'down', emoji: '😞', labelKey: 'Help_Center_Reaction_Down' },
  { value: 'neutral', emoji: '😐', labelKey: 'Help_Center_Reaction_Neutral' },
  { value: 'up', emoji: '😃', labelKey: 'Help_Center_Reaction_Up' },
]

type Props = {
  articleId: number
  countryCode: string
}

/** 「這篇文章有回答您的問題嗎？」：可以改選，送出失敗不打擾使用者（評價不是關鍵功能） */
const Reaction = ({ articleId, countryCode }: Props) => {
  const { t } = useTranslation()
  const [selected, setSelected] = useState<HelpReaction>()

  const handleClick = async (reaction: HelpReaction) => {
    const previous = selected
    setSelected(reaction)
    try {
      await reactHelpArticle({ id: articleId, countryCode, reaction, visitorId: getVisitorId() })
    } catch (error) {
      console.log('reactHelpArticle error:', error)
      setSelected(previous)
    }
  }

  return (
    <div className={cx('help-reaction')}>
      <p className={cx('help-reaction__question')}>{selected ? t('Help_Center_Reaction_Thanks') : t('Help_Center_Reaction_Question')}</p>
      <div className={cx('help-reaction__options')}>
        {REACTIONS.map(({ value, emoji, labelKey }) => (
          <button
            key={value}
            type='button'
            className={cx('help-reaction__option', {
              'help-reaction__option--selected': selected === value,
              'help-reaction__option--dim': selected && selected !== value,
            })}
            aria-label={t(labelKey)}
            aria-pressed={selected === value}
            onClick={() => handleClick(value)}
          >
            {emoji}
          </button>
        ))}
      </div>
    </div>
  )
}

export default Reaction
